import { Navigate, useLocation } from 'react-router-dom'
import { LoginForm } from '@/features/auth/login-form.tsx'
import { useSession } from '@/features/auth/use-session.ts'
import { Logo } from '@/shared/ui/logo.tsx'

interface LocationState {
  from?: string
}

export function LoginPage() {
  const location = useLocation()
  const { data, isPending } = useSession()

  const redirectTo = (location.state as LocationState | null)?.from ?? '/'
  if (!isPending && data) return <Navigate to={redirectTo} replace />

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-5.5 bg-canvas px-5 pt-8 pb-10">
      <div className="flex flex-col items-center gap-1.5">
        <Logo height={26} />
        <div className="text-[12px] text-ink-muted">админка сервиса</div>
      </div>

      <div className="w-full max-w-[416px] rounded-panel border border-line bg-surface px-7.5 pt-7.5 pb-6.5 shadow-panel">
        <LoginForm redirectTo={redirectTo} />
      </div>

      <p className="max-w-[416px] text-center text-[12.5px] text-ink-muted text-balance-pretty">
        Доступ только для сотрудников Manaro. Если не получается войти — напишите на{' '}
        <a href="mailto:support@manaro.io" className="text-brand hover:text-brand-dark">
          support@manaro.io
        </a>
        .
      </p>
    </div>
  )
}
